import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Zap, CheckCircle2, Package } from 'lucide-react';
export function Hero() {
  return <section className="hero-bg relative overflow-hidden text-white pt-10 pb-12 px-5 md:pt-20 md:pb-24" data-id="element-94">
      <div className="hero-pattern absolute inset-0 opacity-50" data-id="element-95"></div>

      <div className="max-w-[720px] mx-auto relative z-10 text-center flex flex-col items-center" data-id="element-96">
        {/* Title */}
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="font-display text-[clamp(44px,10vw,90px)] leading-none tracking-wide mb-3" data-id="element-97">
          <span className="text-gold" data-id="element-98">DEFENDETE</span>
        </motion.h1>

        {/* Subtitle */}
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.1
      }} className="text-[clamp(16px,3vw,22px)] font-medium opacity-90 mb-5 md:mb-6 italic" data-id="element-99">
          La guía que las instituciones no quieren que tengas
        </motion.p>

        {/* Mockup at 70% */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.2,
        duration: 0.5
      }} className="w-[70%] max-w-[460px] mx-auto mb-2" data-id="element-100">
          <img src="https://cdn.magicpatterns.com/uploads/wBtMt5QW72WSuBBYegi5to/MOCKUP.png" alt="DEFENDETE Megapack Ciudadano Mockup" width="920" height="920" loading="eager"
        // @ts-ignore — fetchpriority is a valid HTML attribute
        fetchpriority="high" decoding="async" className="w-full h-auto drop-shadow-2xl" data-id="element-101" />
        </motion.div>

        {/* Description */}
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.35
      }} className="text-[14px] md:text-[16px] opacity-80 max-w-[560px] mb-6 md:mb-8" data-id="element-102">
          Todo lo que necesitás para reclamar lo que te corresponde ante la ART,
          tu empleador, tu propietario, tu obra social y tu banco.
        </motion.p>

        {/* Promise box */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.4
      }} className="inline-block bg-gold/15 border-[1.5px] border-gold rounded-xl py-3 px-5 md:py-4 md:px-7 mb-6 md:mb-8 max-w-[620px]" data-id="element-103">
          <p className="text-[14px] md:text-[17px] font-bold text-gold-light mb-1" data-id="element-104">
            En 45 minutos sabés exactamente qué hacer con tu reclamo.
            <br data-id="element-105" />
            Sin abogado. Sin tecnicismos. Sin perder tiempo.
          </p>
          <small className="text-[11px] md:text-[13px] opacity-70 block" data-id="element-106">
            PDF Digital · Acceso inmediato · Aplicable desde hoy · Todo
            Argentina
          </small>
        </motion.div>

        {/* CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.5
      }} data-id="element-107">
          <motion.a href="#pricing" animate={{
          boxShadow: ['0 6px 30px rgba(201,168,76,0.35)', '0 6px 40px rgba(201,168,76,0.5)', '0 6px 30px rgba(201,168,76,0.35)']
        }} transition={{
          duration: 2,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="inline-block bg-gold text-navy font-display text-[18px] md:text-[22px] tracking-wide py-3.5 px-8 md:py-4 md:px-10 rounded-lg no-underline cursor-pointer transition-all duration-150 hover:-translate-y-0.5" data-id="element-108">
            💥 QUIERO MI DEFENDETE AHORA
          </motion.a>

          <div className="flex justify-center gap-4 md:gap-6 flex-wrap mt-5 md:mt-6 opacity-70 text-[11px] md:text-[13px]" data-id="element-109">
            <span className="flex items-center gap-1.5" data-id="element-110">
              <Shield size={14} data-id="element-111" /> Pago seguro
            </span>
            <span className="flex items-center gap-1.5" data-id="element-112">
              <Zap size={14} data-id="element-113" /> Acceso en 5 min
            </span>
            <span className="flex items-center gap-1.5" data-id="element-114">
              <CheckCircle2 size={14} data-id="element-115" /> Garantía 7 días
            </span>
            <span className="flex items-center gap-1.5" data-id="element-116">
              <Package size={14} data-id="element-117" /> Mercado Pago
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}